import{RecadoTemplateRenderer as e}from"./recado-template-renderer.js";function r(r){return new e(r)}export{r as newTemplates2Renderer};
